// @generated
// This file was automatically generated and should not be edited.
// Run `dev generate pipeline-frontend` to regenerate.

/* eslint-disable unused-imports/no-unused-imports */

// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {ColumnTypeValidationFlag} from 'data-frames/util/validateColumnType';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {PipelineStepDataKind, PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStepShape} from 'pipelines/StepShapeUtils';

export const REGRESSION_STEP_SHAPES = [
  {
    stepType: PipelineStepType.REGRESSION,
    isDeprecated: false,
    version: 0,
    inputDataShapes: {
      'Input dataset': {
        systemName: 'Input dataset',
        displayName: 'Input dataset',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      }
    },
    outputDataShapes: {
      'Model variables': {
        systemName: 'Model variables',
        displayName: 'Model variables',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      },
      'Model output': {
        systemName: 'Model output',
        displayName: 'Model output',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      },
      'Output chart': {
        systemName: 'Output chart',
        displayName: 'Output chart',
        kind: PipelineStepDataKind.CHART,
        isMulti: false,
        isRequired: true
      }
    },
    config: {
      name: {
        kind: 'string',
        required: true
      },
      regressionConfig: {
        kind: 'taggedUnion',
        required: true,
        tagKey: 'modelType',
        choices: [
          {
            kind: 'shape',
            required: true,
            fields: {
              modelType: {
                kind: 'string',
                required: true,
                value: 'LINEAR'
              },
              xColumn: {
                kind: 'columnReference',
                required: true,
                inputDataName: 'Input dataset',
                validationOptions: {
                  allowedLeafTypes: [
                    LeafType.INTEGER,
                    LeafType.DECIMAL
                  ]
                }
              },
              yColumn: {
                kind: 'columnReference',
                required: true,
                inputDataName: 'Input dataset',
                validationOptions: {
                  allowedLeafTypes: [
                    LeafType.INTEGER,
                    LeafType.DECIMAL
                  ]
                }
              },
              weightColumn: {
                kind: 'columnReference',
                required: false,
                inputDataName: 'Input dataset',
                validationOptions: {
                  allowedLeafTypes: [
                    LeafType.INTEGER,
                    LeafType.DECIMAL
                  ]
                }
              },
              partitionColumn: {
                kind: 'columnReference',
                required: false,
                inputDataName: 'Input dataset',
                validationOptions: null
              },
              excludeFlagged: {
                kind: 'boolean',
                required: false
              }
            }
          },
          {
            kind: 'shape',
            required: true,
            fields: {
              modelType: {
                kind: 'string',
                required: true,
                value: 'QUADRATIC'
              },
              xColumn: {
                kind: 'columnReference',
                required: true,
                inputDataName: 'Input dataset',
                validationOptions: {
                  allowedLeafTypes: [
                    LeafType.INTEGER,
                    LeafType.DECIMAL
                  ]
                }
              },
              yColumn: {
                kind: 'columnReference',
                required: true,
                inputDataName: 'Input dataset',
                validationOptions: {
                  allowedLeafTypes: [
                    LeafType.INTEGER,
                    LeafType.DECIMAL
                  ]
                }
              },
              weightColumn: {
                kind: 'columnReference',
                required: false,
                inputDataName: 'Input dataset',
                validationOptions: {
                  allowedLeafTypes: [
                    LeafType.INTEGER,
                    LeafType.DECIMAL
                  ]
                }
              },
              partitionColumn: {
                kind: 'columnReference',
                required: false,
                inputDataName: 'Input dataset',
                validationOptions: null
              },
              excludeFlagged: {
                kind: 'boolean',
                required: false
              }
            }
          },
          {
            kind: 'shape',
            required: true,
            fields: {
              modelType: {
                kind: 'string',
                required: true,
                value: 'LOGISTIC'
              },
              xColumn: {
                kind: 'columnReference',
                required: true,
                inputDataName: 'Input dataset',
                validationOptions: {
                  allowedLeafTypes: [
                    LeafType.INTEGER,
                    LeafType.DECIMAL
                  ]
                }
              },
              yColumn: {
                kind: 'columnReference',
                required: true,
                inputDataName: 'Input dataset',
                validationOptions: {
                  allowedLeafTypes: [
                    LeafType.INTEGER,
                    LeafType.DECIMAL
                  ]
                }
              },
              weightColumn: {
                kind: 'columnReference',
                required: false,
                inputDataName: 'Input dataset',
                validationOptions: {
                  allowedLeafTypes: [
                    LeafType.INTEGER,
                    LeafType.DECIMAL
                  ]
                }
              },
              partitionColumn: {
                kind: 'columnReference',
                required: false,
                inputDataName: 'Input dataset',
                validationOptions: null
              },
              excludeFlagged: {
                kind: 'boolean',
                required: false
              },
              parameterCustomizations: {
                kind: 'array',
                required: false,
                elementSpec: {
                  kind: 'shape',
                  required: true,
                  fields: {
                    name: {
                      kind: 'enum',
                      required: true,
                      choices: [
                        'MIN',
                        'MAX',
                        'IC50',
                        'HILL_SLOPE'
                      ]
                    },
                    initialValue: {
                      kind: 'number',
                      required: false
                    },
                    constraint: {
                      kind: 'taggedUnion',
                      required: true,
                      tagKey: 'type',
                      choices: [
                        {
                          kind: 'shape',
                          required: true,
                          fields: {
                            type: {
                              kind: 'string',
                              required: true,
                              value: 'NONE'
                            }
                          }
                        },
                        {
                          kind: 'shape',
                          required: true,
                          fields: {
                            type: {
                              kind: 'string',
                              required: true,
                              value: 'EQUAL'
                            },
                            value: {
                              kind: 'number',
                              required: true
                            }
                          }
                        },
                        {
                          kind: 'shape',
                          required: true,
                          fields: {
                            type: {
                              kind: 'string',
                              required: true,
                              value: 'LESS_THAN'
                            },
                            upperBound: {
                              kind: 'number',
                              required: true
                            }
                          }
                        },
                        {
                          kind: 'shape',
                          required: true,
                          fields: {
                            type: {
                              kind: 'string',
                              required: true,
                              value: 'GREATER_THAN'
                            },
                            lowerBound: {
                              kind: 'number',
                              required: true
                            }
                          }
                        },
                        {
                          kind: 'shape',
                          required: true,
                          fields: {
                            type: {
                              kind: 'string',
                              required: true,
                              value: 'BETWEEN'
                            },
                            lowerBound: {
                              kind: 'number',
                              required: true
                            },
                            upperBound: {
                              kind: 'number',
                              required: true
                            }
                          }
                        }
                      ]
                    }
                  }
                }
              }
            }
          }
        ]
      }
    }
  }
] as const satisfies ReadonlyArray<PipelineStepShape>;
